import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue';
import i18n from "@/locale/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateButton',
  props: {
  label: {
    type: String,
    default: ''
  },
},
  emits: ["click"],
  setup(__props, { emit }: { emit: ({
  (event: 'click', data: { event: MouseEvent }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

const t = i18n.global.t;

const buttonLabel = ref('');





onMounted(() => {
  if (props.label === '') {
    buttonLabel.value = t("COMMON.BUTTON.CREATE");
  } else {
    buttonLabel.value = props.label;
  }
})

const openNewDialog = (event: MouseEvent) => {
  emit('click', { event });
}


return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_component_Button, {
    class: "p-button-create",
    icon: "pi pi-plus",
    label: buttonLabel.value,
    onClick: openNewDialog
  }, null, 8, ["label"]))
}
}

})